export default __webpack_public_path__ + "static/media/Dr. Rhea.0d70e50c.jpg";